import Aia from "./Aia";
import Aviva from "./Aviva";
import Ge from "./Ge";
import Prudential from "./Prudential";
import Tokiomarine from "./Tokiomarine";
import Axa from "./Axa";

export { Aia, Aviva, Ge, Prudential, Tokiomarine, Axa };



// WEBPACK FOOTER //
// ./components/employee/hdf-forms/index.js